import Moment from 'moment';

export const getTodayReflection = (records, date) => {
  let filtered = records.filter((record) => record.type === 'DailyReflection');
  return filtered.find((record) => {
    return Moment(record.recordTime).isSame(date, 'day');
  });
};
